import { Group, Paper, Pill, Stack, Text } from '@mantine/core';
import { Link } from '@tanstack/react-router';

import { TitleCard } from '@/core/components';

import { AuthorCardList, PublishedAtText } from '@feature/utils';

import { StatusYearCardList } from '../StatusYearCardList';
import { Project } from './../../model/ProjectTypes';
import classes from './ProjectCard.module.css';

export interface ProjectCardProps {
  project: Project;
  to?: string;

  onClick?: () => void;
}

export function ProjectCard({ project, to, onClick }: ProjectCardProps) {
  const {
    title,
    contractValue,
    currency,
    competitionName,
    financing,
    competitionType,
    registrationNumber,
    competition,
    contractNo,
    startDate,
    endDate,
    authors,
    statusYear,
  } = project;

  return (
    <Paper
      className={classes.card}
      component={to ? Link : undefined}
      to={to}
      onClick={onClick}
      p="lg"
      c="var(--mantine-color-text)"
    >
      <Stack gap="4px">
        <TitleCard title={title} />
        <Group gap="xs">
          <PublishedAtText
            c="dimmed"
            size="sm"
            date={startDate}
          />
          <Text c="dimmed">-</Text>
          <PublishedAtText
            c="dimmed"
            size="sm"
            date={endDate}
          />
        </Group>
        <Group gap="xs">
          <Text
            c="dimmed"
            size="sm"
          >
            {financing?.financerName}
          </Text>
          <Text
            c="dimmed"
            size="sm"
          >
            {financing?.type?.name}
          </Text>
          <Text
            c="dimmed"
            size="sm"
          >
            {contractValue} {currency}
          </Text>
        </Group>
        <Group>
          <Pill>
            {competition?.name} {competitionName ? `- ${competitionName}` : ''} {competitionType?.name}
          </Pill>
          {registrationNumber && <Pill>{registrationNumber}</Pill>}
          {contractNo && <Pill>{contractNo}</Pill>}
        </Group>
        <AuthorCardList authors={authors} />
        <StatusYearCardList statusYearList={statusYear} />
      </Stack>
    </Paper>
  );
}
